import { render, staticRenderFns } from "./BattleWinnersEditor.vue?vue&type=template&id=31c1f5ba&scoped=true"
import script from "./BattleWinnersEditor.vue?vue&type=script&lang=js"
export * from "./BattleWinnersEditor.vue?vue&type=script&lang=js"
import style0 from "./BattleWinnersEditor.vue?vue&type=style&index=0&id=31c1f5ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c1f5ba",
  null
  
)

export default component.exports